export default function Process() {
  const steps = [
    {
      number: '1',
      title: 'Free Claim Evaluation',
      description: 'Review of your policy, damage, photos, or any settlement offer you\'ve received.',
      duration: '1-2 days'
    },
    {
      number: '2',
      title: 'Detailed Inspection',
      description: 'Independent assessment to identify all damage, including hidden issues that insurance adjusters often miss.',
      duration: '3-5 days'
    },
    {
      number: '3',
      title: 'Documentation & Submission',
      description: 'Professional estimates and reports submitted on your behalf with comprehensive evidence and documentation.',
      duration: '5-7 days'
    },
    {
      number: '4',
      title: 'Negotiation & Settlement',
      description: 'We handle the adjuster and carrier until your claim is resolved with the maximum settlement you deserve.',
      duration: '2-4 weeks'
    }
  ];

  return (
    <section id="process" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider mb-3">How It Works</div>
          <h2 className="text-5xl font-bold text-[#1e3a5f] mb-4">Our Simple 4-Step Process</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From initial evaluation to final settlement, we guide you through every step of the claims process.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-[#FF6B35]/20">
            <div className="absolute inset-0 bg-[#FF6B35] w-full"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative ${index % 2 === 0 ? 'lg:mt-0' : 'lg:mt-12'}`}
              >
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all">
                  <div className="flex justify-center mb-6">
                    <div className="w-20 h-20 flex items-center justify-center bg-[#FF6B35] rounded-full text-white text-3xl font-bold shadow-lg">
                      {step.number}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-[#1e3a5f] mb-3 text-center">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-4 text-center">{step.description}</p>
                  <div className="text-xs text-gray-400 text-center">
                    <i className="ri-time-line mr-1"></i>
                    Estimated Duration: {step.duration}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
